import React, { useEffect, useState } from 'react'
import * as api from '../api'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import AccountCard from './AccountCard'
import { Card } from 'semantic-ui-react'
import SortAccounts from './SortAccounts'
import LoadingCard from './AccountCard/LoadingCard'
import { isMobile } from 'react-device-detect'


const Accounts = () => {
    const [accountsData, setAccounts] = useState<api.Taccount[]>([])

    function fetchAccounts() {
        api.getAccounts()
            .then(res => setAccounts(prevAccounts =>
                prevAccounts.length === 0 ? onlyOkAccs(res) : updateSavingOrder(prevAccounts, res)
            ))
            .catch((error: AxiosError) => {
                toast.error('Error getting accounts from backend: ' + error.message)
            })
    }

    let Accounts = accountsData.map(acc => <AccountCard account={acc} key={acc._id} fetchAccounts={fetchAccounts} />)

    if (accountsData.length === 0)
        Accounts = Array(10).fill(0).map((_, i) => <LoadingCard key={i} />)

    useEffect(fetchAccounts, [])

    const wrapperClass = isMobile ? 'big-block-mobile' : 'big-block-desktop big-block-margin'
    return (
        <div className={wrapperClass}>
            <SortAccounts accounts={accountsData} setAccounts={setAccounts} />

            <Card.Group centered>
                {Accounts}
            </Card.Group>
            <br />
        </div>
    )
}

export default Accounts

function updateSavingOrder(prevAccounts: api.Taccount[], fetchedAccounts: api.Taccount[]): api.Taccount[] {
    const newList: api.Taccount[] = []

    for (const prevAcc of prevAccounts) {
        for (const currAcc of fetchedAccounts) {
            if (currAcc.status === 'banned') continue

            if (currAcc._id === prevAcc._id) {
                newList.push(currAcc)
                break
            }
        }
    }

    return newList
}

function onlyOkAccs (allAccs: api.Taccount[]): api.Taccount[] {
    return allAccs.map(acc => {
        if (acc.status === 'banned' || acc.status === 'temporary-retrieved')
            acc.notVisible = true
        return acc
    })
}
